import { render, staticRenderFns } from "./PayStay.vue?vue&type=template&id=631bc8c8&scoped=true&"
import script from "./PayStay.vue?vue&type=script&lang=js&"
export * from "./PayStay.vue?vue&type=script&lang=js&"
import style0 from "./PayStay.vue?vue&type=style&index=0&id=631bc8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631bc8c8",
  null
  
)

export default component.exports